import {
    AggregationStrategy,
    PortfolioSummarySortableDataItem,
} from './AggregationStrategy';
import {
    PortfolioSummaryAggregatedData,
    initialiseGroup,
    PortfolioSummaryAggregatedDataGroup,
} from 'widgets/portfolioSummary/store/data/PortfolioSummaryDataState';
import { PortfolioItem } from 'portfolio/PortfolioItem';
import isNil from 'lodash/isNil';
import { AggregationField } from '../fields/aggregationFieldPortfolio';

export class EnumMapAggregationStrategy implements AggregationStrategy {
    public constructor(
        private enumMap: string[],
        public aggregationField: AggregationField,
        public combineSellsAndShorts: boolean
    ) {}

    public initialiseAggregatedData(): PortfolioSummaryAggregatedData {
        const ret: PortfolioSummaryAggregatedData = {};
        for (const enumValue of this.enumMap) {
            ret[enumValue] = initialiseGroup(
                enumValue,
                this.combineSellsAndShorts
            );
        }
        if (ret['N/A']) {
            ret['N/A'].total.selectionDisabled = true;
        }
        return ret;
    }

    public getAggregationGroup(
        data: PortfolioSummaryAggregatedData,
        item: PortfolioItem
    ): PortfolioSummaryAggregatedDataGroup {
        const groupName = this.getGroupName(item);
        return data[groupName];
    }

    public filterPortfolio(
        filteredPortfolio: PortfolioItem[],
        groupName: string
    ): PortfolioItem[] {
        return filteredPortfolio.filter((item) => {
            const value = this.getGroupName(item);
            return value === groupName;
        });
    }

    public getDrillDowns(
        data: PortfolioSummaryAggregatedData,
        item: PortfolioItem
    ) {
        return this.getAggregationGroup(data, item).drillDowns;
    }

    public sort(
        x: PortfolioSummarySortableDataItem,
        y: PortfolioSummarySortableDataItem
    ): number {
        const xIndex = this.enumMap.indexOf(x.groupName);
        const yIndex = this.enumMap.indexOf(y.groupName);
        return xIndex - yIndex;
    }

    public groupNameToValue(groupName: string) {
        if (groupName === 'N/A') {
            return '';
        }
        return this.enumMap.indexOf(groupName).toString();
    }

    private getGroupName(item: PortfolioItem): string {
        const value = item[this.aggregationField];
        if (isNil(value)) {
            return 'N/A';
        }
        return this.enumMap[value! as number] ?? 'N/A';
    }
}
